import { orderBy } from 'lodash-es';
import { postAsUriParameters } from '@namespace/helpers';
import { CityItem } from '../../types/common';
import { GetCitiesParams, GetCitiesResponse } from './types';

export const getCities = ({
  walletHash,
  cashdesk,
  language
}: GetCitiesParams) =>
  postAsUriParameters<GetCitiesResponse>('/accounting/api/get_city_list', {
    wallet_hash: walletHash,
    cashdesk,
    lang: language
  }).then((data: GetCitiesResponse) =>
    orderBy(data.response as Record<string, CityItem>, 'name')
  );
